import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

const EMPTY_WAIT_END = 3000;

export default function DialogLineWithoutAudioPlayer(props) {
   const { selected, onEnded, paused } = props;

   const timerRef = useRef(null);

   useEffect(() => {
        if(timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    
        if(!selected || paused) return;

        timerRef.current = setTimeout(() => {
            onEnded();
        }, EMPTY_WAIT_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected, paused])

    return null
}

DialogLineWithoutAudioPlayer.propTypes = {
    onEnded: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    paused: PropTypes.bool
}